import styled, { css } from 'styled-components';
import { ADividerOrientation } from './ADivider.types';

export const Wrapper = styled.hr<{ orientation: ADividerOrientation }>`
  /* Begin reset: hr */
  box-sizing: border-box;
  overflow: hidden;
  margin: 0;
  border: 0;
  /* End reset */

  display: block;
  ${({ orientation }) =>
    orientation === ADividerOrientation.Vertical
      ? css`
          inline-size: 1px;
          min-block-size: 100%;
          flex-shrink: 0;
          align-self: stretch;
        `
      : css`
          block-size: 1px;
          inline-size: 100%;
        `}
`;
